export enum Ga4OffersElementKey {
    SEND_CALCULATION_INIT = 'SEND_CALCULATION_INIT',
    SEND_CALCULATION_PROCEED = 'SEND_CALCULATION_PROCEED',
    DRIVER_SOS_BANNER = 'DRIVER_SOS_BANNER',
    ACCIDENTS_HAPPEN_BANNER = 'ACCIDENTS_HAPPEN_BANNER',
    EDIT_DATA_LIST = 'EDIT_DATA_LIST',
    EDIT_DATA_COMPARISON = 'EDIT_DATA_COMPARISON',
    OFFER_DETAILS = 'OFFER_DETAILS',
    COMPARE_OFFERS_ADD = 'COMPARE_OFFERS_ADD',
    COMPARE_OFFERS_PROCEED = 'COMPARE_OFFERS_PROCEED',
    ORDER_CALL = 'ORDER_CALL',
    BUY_ONLINE_MODAL = 'BUY_ONLINE_MODAL',
    BUY_ONLINE_LIST = 'BUY_ONLINE_LIST',
    SORT_OFFERS = 'SORT_OFFERS',
}
